import React from 'react';
import PropTypes from 'prop-types';
import { Icon, List, Collapse } from '@pella/sash-framework';
import { CTA } from '../../..';

const MobileStandardMenu = ({ data, onBackClick }) => {
	if (!data?.standard?.[0]) return null;

	return (
		<div className={`mobileChildMenu absolute -right-[320px] top-0 flex h-full w-full flex-col overflow-hidden overflow-y-auto bg-white transition-all duration-300`}>
			<button
				className='flex w-full items-center border-y border-y-gray-10 bg-gray-3 px-4 py-1'
				onClick={onBackClick}
			>
				<Icon
					name='keyboard_arrow_left'
					size={24}
				/>
				<span className='ml-1 text-sm font-semibold uppercase'>Main Menu</span>
			</button>

			<List bullets='none'>
				{data.standard.map((category, index) => (
					<li key={index}>
						<Collapse
							className='!border-b-0'
							isOpen
						>
							<Collapse.Trigger
								className='bg-white !py-3 px-4 text-lg font-semibold text-secondary-dark shadow-[0_4px_6px_rgba(0,0,0,0.05)] [&+div]:px-4 [&_button]:pointer-events-none [&_span>span]:hidden'
								renderAs='p'
							>
								{data.heading}
							</Collapse.Trigger>

							<Collapse.Content>
								{category.cta?.[0] && (
									<List
										key={index}
										bullets='none'
									>
										{category.cta.map((cta, index) => (
											<li key={index}>
												<CTA
													data={cta}
													className='block py-3 text-base font-semibold no-underline'
												/>
											</li>
										))}
									</List>
								)}
							</Collapse.Content>
						</Collapse>
					</li>
				))}
			</List>

			{data.cta?.[0] && (
				<div className='mt-auto p-4'>
					<CTA
						data={data.cta[0]}
						className='!flex items-center justify-center py-3 [&>span]:mr-2 [&_span]:!text-base'
					/>
				</div>
			)}
		</div>
	);
};

MobileStandardMenu.propTypes = {
	data: PropTypes.object,
	onBackClick: PropTypes.func,
};

export default MobileStandardMenu;
